module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_troendelag_pos.1f9b2067.png";